const samdeskCdnUrl = "https://cdn.samdesk.io";

export const bubblesUrl = `${samdeskCdnUrl}/sounds/bubbles.mp3`;
export const chimesUrl = `${samdeskCdnUrl}/sounds/chimes.mp3`;
export const sonarUrl = `${samdeskCdnUrl}/sounds/sonar.mp3`;
export const woodBlocksUrl = `${samdeskCdnUrl}/sounds/wood_blocks.mp3`;
